import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters, mapActions } from 'vuex';
import VipIcon from '@tencent/vft-ui/src/VipIcon/VipIcon.vue';
import { PropertyBelong } from './util';
export default {
  props: ['item', 'eggImg', 'eggInfo', 'masterEggInfo', 'shareCode', 'masterEggImg', 'myEggImg'],
  settingKey: '碰蛋动画',
  setting: {
    明星背景动画: {
      type: 'array',
      default: [{
        明星: '杨超越',
        背景: '101'
      }, {
        明星: '孟美岐',
        背景: '101'
      }, {
        明星: '吴宣仪',
        背景: '101'
      }, {
        明星: 'sunnee',
        背景: '101'
      }, {
        明星: '徐梦洁',
        背景: '101'
      }, {
        明星: 'yamy',
        背景: '101'
      }, {
        明星: '傅菁',
        背景: '101'
      }, {
        明星: '李紫婷',
        背景: '101'
      }, {
        明星: '段奥娟',
        背景: '101'
      }, {
        明星: '赖美云',
        背景: '101'
      }, {
        明星: '成龙',
        背景: 'Jackie'
      }, {
        明星: '雷佳音',
        背景: '101'
      }, {
        明星: '毛不易',
        背景: 'Mao'
      }, {
        明星: '魏无羡',
        背景: 'Wei'
      }, {
        明星: '外星人',
        背景: 'Default'
      }],
      items: {
        type: 'object',
        properties: {
          明星: '杨超越',
          背景: '101'
        }
      }
    },
    动效播放延时: 300,
    动效时长: 1500
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapState(['isLogin']), mapGetters(['userInfo', 'payVip', 'myShareCode', 'isOfficial']), {
    isStarCode: function isStarCode() {
      return this.item.other.type === 5;
    },
    starBgType: function starBgType() {
      var _this = this;

      if (this.isStarCode) {
        var item = this.setting.明星背景动画.find(function (item) {
          return item.明星 === _this.item.other.name;
        });
        return item ? item.背景 : 'Default';
      } else {
        return false;
      }
    },
    daoDanClass: function daoDanClass() {
      if (this.isStarCode) {
        return 'ani';
      } else {
        return ['ani', 'dao_left', 'dao_right', 'ani'][this.item.property_belong];
      }
    },
    isYoo: function isYoo() {
      return this.item.my.egg_type === 1 || this.item.my.egg_type === 3 || this.item.other.egg_type === 1 || this.item.other.egg_type === 3 || this.isStarCode;
    },
    bgType: function bgType() {
      if (this.starBgType) {
        return this.starBgType;
      } else if (this.daoDanClass !== 'ani') {
        return 'Dao';
      } else if (this.isYoo) {
        return 'Yoo';
      } else {
        return 'Default';
      }
    }
  }),
  components: {
    VipIcon: VipIcon
  },
  mounted: function mounted() {
    var _this2 = this;

    var type = this.bgType; //普通蛋: Default
    //101蛋: 101
    //yoo蛋: Yoo
    //成龙: Jackie
    //毛不易: Mao
    //魏某: Wei
    //小捣蛋: Dao

    setTimeout(function () {
      window.bodymovin.loadAnimation({
        // path: process.env.NODE_ENV === 'development' ? '/pengLottieFront/data.json' : '//vm.gtimg.cn/tencentvideo/script/film/v3/d2d/pengLottieFront/data.json', //json文件路径
        path: '//vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/animate/act_2019cny/pengLottieFront/data.json',
        loop: false,
        autoplay: true,
        renderer: 'svg',
        //渲染方式，有"html"、"canvas"和"svg"三种
        container: document.getElementById('pengLottieFront')
      });
      window.bodymovin.loadAnimation({
        // path: process.env.NODE_ENV === 'development' ? '/yoolottie/data.json' : '//vm.gtimg.cn/tencentvideo/script/film/v3/d2d/pengLottie101/data.json', //json文件路径
        path: '//vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/animate/act_2019cny/pengLottie' + type + '/data.json',
        // path: process.env.NODE_ENV === 'development' ? '/pengLottie'+type+'/data.json' : '//vm.gtimg.cn/tencentvideo/script/film/v3/d2d/pengLottie101/data.json', //json文件路径
        loop: false,
        autoplay: true,
        renderer: 'svg',
        //渲染方式，有"html"、"canvas"和"svg"三种
        container: document.getElementById('pengLottieBack')
      });
      setTimeout(function () {
        _this2.$emit('animateSuccess');
      }, _this2.setting.动效时长);
    }, this.setting.动效播放延时);
  }
};